export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function randomNumber(minimum, maximum) {
    return Math.round(Math.random() * (maximum - minimum) + minimum);
}